import { Customer } from 'types/Customer';

import {
  TOGGLE_APPLY_TAF_LOGIC,
  SELECTED_ENTITY_TYPE,
  SET_GLOBAL_ENTITY_BY_TYPE,
  RESET_PRODUCT_DETAILS,
  TOOGLE_EDIT_MODE,
  SET_EDIT_STATE,
  RESET_EDIT_STATE,
  SET_PRODUCTS_STATE,
  SET_CUSTOMER_LAST_USED_ENTITIES,
  DISPLAY_PREVIOUS_ENTITIES,
  SET_FIT_ID,
} from './actionTypes';
import {
  entityObject,
  getIsMedicalEntitySelected,
  getIsSchoolEntitySelected,
  getTafReduxState,
} from './reducers';

export const toggleApplyTafLogic = (applyLogic: boolean) => {
  return {
    type: TOGGLE_APPLY_TAF_LOGIC,
    payload: applyLogic,
  };
};

export const setGlobalEntity = (entityData: entityObject) => {
  return {
    type: SET_GLOBAL_ENTITY_BY_TYPE,
    payload: entityData,
  };
};

export const setSelectedEntity = (selectedEntityType: string) => {
  return {
    type: SELECTED_ENTITY_TYPE,
    payload: selectedEntityType,
  };
};

export const updateProductsState = (indexes: number[]) => (
  dispatch,
  getState,
) => {
  const state = getState();
  const {
    productsState,
    editState,
    isEditMode,
    globalSchoolEntity,
    globalMedicalEntity,
  } = getTafReduxState(state);

  const isSchoolSelected = getIsSchoolEntitySelected(state);
  const isMedicalSelected = getIsMedicalEntitySelected(state);

  const updatedProducts = { ...productsState };

  if (isSchoolSelected || isMedicalSelected) {
    const { newEntityType, newEntityName, newEntityID } = editState;

    indexes.forEach(indexValue => {
      if (updatedProducts[indexValue]) {
        if (isEditMode) {
          updatedProducts[indexValue][
            newEntityType === 'association' ? 'schoolEntity' : 'medicalEntity'
          ] = {
            entityType: newEntityType,
            entityID: newEntityID,
            entityName: newEntityName ?? '',
          };
          return;
        }

        updatedProducts[indexValue].schoolEntity = globalSchoolEntity;
        updatedProducts[indexValue].medicalEntity = globalMedicalEntity;
        return;
      }

      updatedProducts[indexValue] = {
        schoolEntity: globalSchoolEntity,
        medicalEntity: globalMedicalEntity,
      };
    });

    return dispatch({
      type: SET_PRODUCTS_STATE,
      payload: updatedProducts,
    });
  }
};

export const resetEntityInProduct = (
  orderIndex: number,
  entityType: string,
) => (dispatch, getState) => {
  const { productsState } = getTafReduxState(getState());

  productsState[orderIndex][
    entityType === 'association' ? 'schoolEntity' : 'medicalEntity'
  ] = {
    entityID: undefined,
    entityName: '',
    entityType: '',
  };

  dispatch({
    type: SET_PRODUCTS_STATE,
    payload: productsState,
  });
};

export const removeProductInTafState = (orderIndex: number) => (
  dispatch,
  getState,
) => {
  const { productsState } = getTafReduxState(getState());
  delete productsState[orderIndex];

  dispatch({
    type: SET_PRODUCTS_STATE,
    payload: productsState,
  });
};

export const toggleEditMode = (isEditMode: boolean) => {
  return {
    type: TOOGLE_EDIT_MODE,
    payload: isEditMode,
  };
};

export const setEditState = (editState: {
  selectedOrderIndex?: number;
  newEntityType?: string;
  newEntityID?: number | string;
  newEntityName?: string;
}) => {
  return {
    type: SET_EDIT_STATE,
    payload: editState,
  };
};

export const setCustomerLastUsedEntities = (previousEntities: {
  previousAssociations: Customer[];
  previousProffesionals: Customer[];
}) => {
  return {
    type: SET_CUSTOMER_LAST_USED_ENTITIES,
    payload: previousEntities,
  };
};

export const toggleDisplayPreviousEntities = (displayEntities: boolean) => {
  return {
    type: DISPLAY_PREVIOUS_ENTITIES,
    payload: displayEntities,
  };
};

export const resetTafState = () => dispatch => {
  dispatch({
    type: SELECTED_ENTITY_TYPE,
    payload: '',
  });
  dispatch(
    setGlobalEntity({
      entityType: 'association',
      entityID: undefined,
      entityName: '',
    }),
  );
  dispatch(
    setGlobalEntity({
      entityType: 'proffesional',
      entityID: undefined,
      entityName: '',
    }),
  );
  dispatch({
    type: RESET_PRODUCT_DETAILS,
  });
  dispatch({
    type: SET_FIT_ID,
    payload: '',
  });
  dispatch({
    type: TOGGLE_APPLY_TAF_LOGIC,
    payload: false,
  });
};

export const resetEditState = () => dispatch => {
  dispatch({
    type: TOOGLE_EDIT_MODE,
    payload: false,
  });
  dispatch({
    type: RESET_EDIT_STATE,
  });
};

export const setFitIDInRedux = (id: string) => {
  return {
    type: SET_FIT_ID,
    payload: id,
  };
};
